import { render, staticRenderFns } from "./AgendamentoPage.vue?vue&type=template&id=60e7cdf1"
import script from "./AgendamentoPage.vue?vue&type=script&lang=js"
export * from "./AgendamentoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports